import React, {useContext, useState} from 'react';
import '../Keyboard.css';
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";

type KeyProps = {
    label?: string;
    onPress: () => void;
    hasHint: boolean;
}

const HintKey: React.FC<KeyProps> = ({onPress, hasHint}) => {
    const [pressed, setPressed] = useState(false);
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);

    const handleKeyPress = () => {
        if (hasHint) return; // 如果有提示，则不响应按键
        setPressed(true);
        setTimeout(() => setPressed(false), 200); // 按键后的状态持续时间
        onPress();
    };

    return (
        <div
            className={`keyboard-hint-btn-container ${hasHint ? 'keyboard-hint-btn-container-unable' : 'keyboard-hint-btn-container-enable'} ${pressed ? 'key-pressed' : ''}`}
            onClick={handleKeyPress}>
            {hasHint ?
                <img className="keyboard-hint-btn-icon" src={imgUrls.hintKeyboardGreyIconUrl}
                     alt="hint"/>
                :<img className="keyboard-hint-btn-icon" src={imgUrls.hintKeyboardWhiteIconUrl}
                      alt="hint"/>
            }
        </div>
    );
};

export default HintKey;